import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Returns role info for the current user in the Manufacturing module.
 * Mirrors backend `require_mfg_role` (case-insensitive):
 *   owner    → all writes (masters, opening stock, orders, production, dispatch)
 *   operator → production + dispatch writes only
 *   viewer   → read-only (any other/unknown role is treated as viewer)
 */
export function useMfgRole() {
  const { user } = useAuth();
  const role = String(user?.role || 'viewer').toLowerCase();
  const isOwner = role === 'owner';
  const isOperator = role === 'operator';
  const isViewer = !isOwner && !isOperator;

  return { role, isOwner, isOperator, isViewer, canWrite: isOwner || isOperator };
}

/** Tiny muted badge shown next to page titles for viewer-role users. */
export function MfgReadOnlyBadge() {
  const { isViewer } = useMfgRole();
  if (!isViewer) return null;
  return (
    <span
      data-testid="mfg-readonly-badge"
      title="Your role has view-only access to Manufacturing"
      className="px-1.5 py-0.5 rounded text-[9px] font-bold uppercase tracking-wider bg-gray-100 text-gray-500 align-middle"
    >
      Read-only
    </span>
  );
}
